// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"kv-z","imageAndVideoCount":"lv-z","imageAndVideoContainer":"mv-z","viewAllReviews":"nv-z"};